<template>
  <div class="currency-formatter mb-1">
    <div class="field-container mr-1">
      <text-field
        id="format-field"
        label="Format"
        placeholder="E.g.: @symbol@n"
        v-model="format"
      />
      <text-field
        id="culture-code"
        label="Culture Code"
        placeholder="E.g.: en-GB"
        v-model="cultureCode"
      />
    </div>
    <div class="buttons">
      <button
        class="btn btn-primary"
        type="button"
        :disabled="resolveDisabled"
        @click="resolveClicked"
      >
        Resolve
      </button>
      <help-link page="currency-formats" class="help-link" />
    </div>
  </div>
</template>
<script>
import HelpLink from "@/components/common/help/HelpLink.vue";

const DEFAULT_CULTURE = "en-GB";

export default {
  components: { HelpLink },
  props: {
    field: {
      required: true,
    },
  },
  data: function() {
    return {
      format: "@symbol@n",
      cultureCode: DEFAULT_CULTURE,
    };
  },
  computed: {
    query: function() {
      return this.field.value.queries.find(
        (q) => q.query.name === "query.currencyFormat"
      );
    },
    resolveDisabled: function() {
      return !this.format && !this.cultureCode;
    },
  },
  methods: {
    resolveClicked: function() {
      const args = { format: this.format };
      if (this.cultureCode !== DEFAULT_CULTURE) {
        args.cultureCode = this.cultureCode;
      }

      this.logDebug("Resolving currency format.", {
        args,
        fieldQueryName: this.query.name,
      });
      
      this.$emit("resolve", {
        args,
        fieldQueryName: this.query.name,
      });
    },
  },
  emits: ["resolve"],
};
</script>
<style lang="scss" scoped>
.currency-formatter {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > .field-container {
    flex-grow: 1;
  }

  & > .buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    & > .help-link {
      margin-left: 3px;
    }
  }
}
</style>
